import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment-timezone';
import Modal from '@material-ui/core/Modal';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Drawer,
  InputLabel,
  MenuItem,
  Paper,
  TextField,
  Typography
} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { ja } from 'date-fns/locale';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
// import Grid from '@material-ui/core/Grid';
// import { Autocomplete } from '@material-ui/lab';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import BudgetTable from '../organisms/BudgetTable';
import ShashokuAdd from '../organisms/ShashokuAdd';
import SearchButton from '../../components/atoms/SearchButton';
import { getAccounts } from '../../actions/Accounts';
import {
  getGroupBudgets,
  getConnectSystemUrl,
  GET_GROUP_BUDGETS_SUCCESS,
  GET_CONNECT_SYSTEM_URL_SUCCESS,
  confirmBudgetStatus,
  putGroupBudgets,
  CONFIRM_BUDGETS_STATUS_SUCCESS,
  sendBudgetEmail,
  // SEND_BUDGET_EMAIL_SUCCESS,
  addShashoku,
  ADD_SHASHOKU_SUCCESS,
  PUT_GROUP_BUDGETS_SUCCESS
} from '../../actions/Budgets';
import ConfirmDialog from '../../components/molecules/ConfirmDialog';
import { getSystems } from '../../actions/Systems';
import 'moment/locale/ja';

import EditBudgetGroupDialog from '../../components/molecules/EditBudgetGroupDialog';

moment.locale('ja');

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  displayFlex: {
    display: 'flex'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    marginTop: 16,
    width: '300px',
    minWidth: 300
  },
  boxMargin: {
    marginTop: 16,
    marginBottom: 8,
    width: '300px',
    minWidth: 300
  },
  pageTitileDiv: {
    backgroundColor: '#fff',
    paddingLeft: 15
  },
  mainPaper: {
    margin: 15
  },
  inputLabel: {
    fontSize: 12
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      budgets: state.groupBudgets.budgets,
      account: state.accounts.account,
      systems: state.systems.list
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          getGroupBudgets,
          confirmBudgetStatus,
          getSystems,
          getConnectSystemUrl,
          sendBudgetEmail,
          addShashoku,
          putGroupBudgets
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  // withState('fromSystemId', 'setFromSystemId', null),
  withState('address', 'setAddress', null),
  withState('groupId', 'setGroupId', null),
  withState('groupName', 'setGroupName', null),
  withState('fromDate', 'setFromDate', null),
  withState('budgetStatus', 'setBudgetStatus', ''),
  withState('toDate', 'setToDate', null),
  withState('page', 'setPage', 1),
  withState('openTable', 'updateOpenTable', false),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('loading', 'updateLoading', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('openConfirmDialog', 'setOpenConfirmDialog', false),
  withState('selectedBudgetIds', 'setSelectedBudgetIds', []),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('selectedConnectSystemIds', 'setSelectedConnectSystemIds', []),
  withState('openSendEmailConfirm', 'setOpenSendEmailConfirm', false),
  withState('openShashokuAddModal', 'setOpenShashokuAddModal', false),
  withState('edittingBudget', 'setEdittingBudget', null),
  withState('openEditBudgetModal', 'setOpenEditBudgetModal', false),
  withState('newBudgetAmount', 'setNewBudgetAmount', ''),
  withState('checkState', 'setCheckState', false),
  withState('checkedBudgetIds', 'setCheckedBudgetIds', () => {
    return new Set();
  }),
  withState('checkedSystemIds', 'setCheckedSystemIds', () => {
    return new Set();
  }),
  withState('listMonths', 'setListMonths', () => {
    const tmp = [{ value: '202011', label: '2020/11' }];
    const today = new Date();
    const milestone = new Date('Nov 01, 2020');
    while (
      !(
        milestone.getFullYear() === today.getFullYear() &&
        milestone.getMonth() === today.getMonth()
      )
    ) {
      milestone.setMonth(milestone.getMonth() + 1);
      const tmpDate = new Date(milestone);
      let tmpMonth = tmpDate.getMonth() + 1;
      if (tmpMonth < 10) {
        tmpMonth = `0${tmpMonth}`;
      }
      tmp.push({
        value: `${milestone.getFullYear()}${tmpMonth}`,
        label: `${milestone.getFullYear()}/${tmpMonth}`
      });
    }
    return tmp;
  }),
  withState('defaultMonth', 'setDefaultMonth', () => {
    return new Date();
  }),
  withHandlers({
    checkSession: props => data => {
      if (
        data.error === true &&
        typeof data.payload !== 'undefined' &&
        data.payload.status === 403
      ) {
        sendLogin(props);
      }
      return data;
    }
  }),
  withHandlers({
    handleChangePage: props => (event, page, limit) => {
      const limitNum = limit || props.rowsPerPage;
      console.log('HANDLE CHANGE PAGE');
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);
      const month =
        props.defaultMonth.getMonth() < 9
          ? `0${props.defaultMonth.getMonth() + 1}`
          : `${props.defaultMonth.getMonth() + 1}`;
      // const budgetMonth = `${props.defaultMonth.getFullYear()}/${month}`;
      const searchKey = {
        connectSystemId: props.fromSystemId
          ? props.fromSystemId.connectSystemId
          : undefined,
        groupId: props.groupId,
        groupName: props.groupName,
        year: props.defaultMonth.getFullYear(),
        month: `${month}`,
        requestStatus: props.budgetStatus,
        page,
        limit: limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions.getGroupBudgets(searchKey).then(data => {
        props.checkSession(data);
        if (data.type === GET_GROUP_BUDGETS_SUCCESS) {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        } else {
          props.setErrorMessage('エラーが発生しました！');
          props.updateLoading(false);
          props.updateOpenProgress(false);
        }
      });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.actions.getSystems();
        this.props.handleChangePage(null, 1, this.props.rowsPerPage);
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    openDrawer,
    updateOpenDrawer,
    account,
    openTable,
    updateOpenTable,
    openProgress,
    updateOpenProgress,
    page,
    handleChangePage,
    loading,
    updateLoading,
    rowsPerPage,
    setRowsPerPage,
    resultMessage,
    setResultMessage,
    openConfirmDialog,
    setOpenConfirmDialog,
    selectedBudgetIds,
    setSelectedBudgetIds,
    checkedBudgetIds,
    setCheckedBudgetIds,
    checkedSystemIds,
    setCheckedSystemIds,
    setDefaultMonth,
    groupId,
    setGroupId,
    groupName,
    setGroupName,
    budgetStatus,
    setBudgetStatus,
    errorMessage,
    setErrorMessage,
    defaultMonth,
    selectedConnectSystemIds,
    setSelectedConnectSystemIds,
    openSendEmailConfirm,
    setOpenSendEmailConfirm,
    openShashokuAddModal,
    setOpenShashokuAddModal,
    edittingBudget,
    setEdittingBudget,
    openEditBudgetModal,
    setOpenEditBudgetModal,
    newBudgetAmount,
    setNewBudgetAmount,
    // budgets,
    checkState,
    setCheckState
  }) => {
    function uncheckAll() {
      setCheckedBudgetIds(new Set());
      setCheckedSystemIds(new Set());
      setCheckState(false);
    }

    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, rowsPerPage);
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const onChangeBudgetStatus = ids => {
      if (ids.length === 0) {
        setErrorMessage('データを選択してください。');
        return;
      }
      setSelectedBudgetIds(ids);
      setOpenConfirmDialog(true);
    };

    const onSendBudgetEmail = ids => {
      if (ids.length === 0) {
        setErrorMessage('データを選択してください。');
        return;
      }
      setSelectedConnectSystemIds(ids);
      setOpenSendEmailConfirm(true);
    };

    const onEditBudget = budget => {
      setEdittingBudget(budget);
      setOpenEditBudgetModal(true);
      setNewBudgetAmount('');
    };

    const handleEditBudget = amount => {
      setOpenEditBudgetModal(false);
      updateLoading(true);
      updateOpenProgress(true);
      actions
        .putGroupBudgets({
          budgetId: edittingBudget.budgetId,
          requestAmount: amount
        })
        .then(data => {
          checkSession(data);
          if (data.type === PUT_GROUP_BUDGETS_SUCCESS) {
            updateOpenProgress(false);
            setResultMessage('予算修正が完了しました。');
            updateLoading(false);
            handleChangePage(null, page, rowsPerPage);
          } else {
            setErrorMessage('エラーが発生しました！');
            updateLoading(false);
            updateOpenProgress(false);
          }
        });
    };

    const changeBudgetStatusList = ids => {
      setOpenConfirmDialog(false);
      updateLoading(true);
      updateOpenProgress(true);
      // const budgetConfirms = ids.map(item => {
      //   const found = budgets.find(el => el.budgetRequestId === item);
      //   return {
      //     budgetRequestIds: found.budgetRequestId,
      //     status: 1
      //   };
      // });
      actions
        .confirmBudgetStatus({ budgetRequestIds: ids, status: 1 })
        .then(data => {
          checkSession(data);
          if (data.type === CONFIRM_BUDGETS_STATUS_SUCCESS) {
            // uncheckAll();
            // updateOpenProgress(false);
            setResultMessage('更新しました。');
            updateLoading(false);
            // handleChangePage(null, page, rowsPerPage);
          } else {
            setErrorMessage('更新に失敗しました。');
            updateLoading(false);
            updateOpenProgress(false);
          }
        });
    };

    const sendBudgetEmailAction = ids => {
      // const month =
      //   defaultMonth.getMonth() < 9
      //     ? `0${defaultMonth.getMonth() + 1}`
      //     : `${defaultMonth.getMonth() + 1}`;
      // const budgetMonth = `${defaultMonth.getFullYear()}/${month}`;

      setOpenSendEmailConfirm(false);
      updateLoading(true);
      updateOpenProgress(true);
      actions
        .confirmBudgetStatus({ budgetRequestIds: ids, status: 0 })
        .then(data => {
          checkSession(data);
          if (data.type === CONFIRM_BUDGETS_STATUS_SUCCESS) {
            // uncheckAll();
            // updateOpenProgress(false);
            setResultMessage('メールを送信しました。');
            updateLoading(false);
            // handleChangePage(null, page, rowsPerPage);
          } else {
            setErrorMessage('エラーが発生しました！');
            updateLoading(false);
            updateOpenProgress(false);
          }
        });
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
      updateLoading(true);
      handleChangePage(null, page, rowsPerPage);
    };

    const handleChangeMonth = e => {
      if (e !== '') {
        setDefaultMonth(e);
      }
    };

    const loginToShashoku = systemId => {
      updateLoading(true);
      updateOpenProgress(true);
      actions.getConnectSystemUrl(systemId).then(data => {
        checkSession(data);
        if (data.type === GET_CONNECT_SYSTEM_URL_SUCCESS) {
          updateOpenProgress(false);
          setResultMessage('');
          updateLoading(false);
          window.open(data.payload);
        } else {
          setErrorMessage('エラーが発生しました！');
          updateLoading(false);
          updateOpenProgress(false);
        }
      });
    };

    const addNewShashoku = param => {
      updateLoading(true);
      updateOpenProgress(true);
      actions.addShashoku(param).then(data => {
        checkSession(data);
        if (data.type === ADD_SHASHOKU_SUCCESS) {
          setOpenShashokuAddModal(false);
          updateLoading(false);
          updateOpenProgress(false);
          setResultMessage('社食ごちめしシステムを追加しました。');
          handleChangePage(null, page, rowsPerPage);
        } else {
          setErrorMessage('エラーが発生しました！');
          updateLoading(false);
          updateOpenProgress(false);
        }
      });
    };

    const cancelAction = () => {
      setOpenShashokuAddModal(false);
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            グループ入金管理
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <MuiPickersUtilsProvider
              utils={DateFnsUtils}
              locale={ja}
              libInstance={moment}
            >
              <div className={classes.boxMargin}>
                <InputLabel className={classes.inputLabel}>該当月</InputLabel>
                <DatePicker
                  variant="inline"
                  openTo="year"
                  format="y/M"
                  views={['year', 'month']}
                  value={defaultMonth}
                  onChange={handleChangeMonth}
                />
              </div>
              {/* </Grid> */}
            </MuiPickersUtilsProvider>
            <div className={classes.displayFlex}>
              <TextField
                label="グループID"
                type="search"
                className={classes.textField}
                margin="normal"
                value={groupId}
                onChange={e => {
                  setGroupId(e.target.value);
                }}
              />
              <TextField
                label="グループ名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={groupName}
                onChange={e => {
                  setGroupName(e.target.value);
                }}
              />
              <TextField
                select
                label="更新状況"
                className={classes.textField}
                margin="normal"
                value={budgetStatus}
                onChange={e => {
                  setBudgetStatus(e.target.value || '');
                }}
                InputLabelProps={{
                  shrink: budgetStatus !== ''
                }}
              >
                <MenuItem id="">選択なし</MenuItem>
                <MenuItem key="0" value="0">
                  未入金
                </MenuItem>
                <MenuItem key="1" value="1">
                  入金済
                </MenuItem>
              </TextField>
            </div>

            <div className={classes.buttonGroupLeft}>
              <SearchButton onClickAction={searchAction} />
            </div>
          </div>
          {openTable && (
            <BudgetTable
              page={page}
              handleChangePage={handleChangePage}
              progress={progress}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setResultMessage={setResultMessage}
              updateOpenProgress={updateOpenProgress}
              updateLoading={updateLoading}
              onChangeBudgetStatus={onChangeBudgetStatus}
              onSendBudgetEmail={onSendBudgetEmail}
              selectedBudgetIds={selectedBudgetIds}
              checkedBudgetIds={checkedBudgetIds}
              setCheckedBudgetIds={setCheckedBudgetIds}
              checkedSystemIds={checkedSystemIds}
              setCheckedSystemIds={setCheckedSystemIds}
              loginToShashoku={loginToShashoku}
              openShashokuAddModal={() => setOpenShashokuAddModal(true)}
              onEditBudget={onEditBudget}
              checkState={checkState}
              setCheckState={setCheckState}
              uncheckAll={uncheckAll}
            />
          )}
        </Paper>
        <Modal open={openShashokuAddModal}>
          <ShashokuAdd
            addNewShashoku={addNewShashoku}
            cancelAction={cancelAction}
          />
        </Modal>
        <ConfirmDialog
          openConfirm={openConfirmDialog}
          updateOpenConfirm={setOpenConfirmDialog}
          message={
            selectedBudgetIds.length > 1
              ? '一括変更してメールを送信しますか？'
              : '個別変更してメールを送信しますか？'
          }
          okAction={() => changeBudgetStatusList(selectedBudgetIds)}
        />

        <ConfirmDialog
          openConfirm={openSendEmailConfirm}
          updateOpenConfirm={setOpenSendEmailConfirm}
          message={
            selectedConnectSystemIds.length > 1
              ? 'メールを送信してよろしいですか？'
              : 'メールを送信してよろしいですか？'
          }
          okAction={() => sendBudgetEmailAction(selectedConnectSystemIds)}
        />
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />

        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => setErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />

        <EditBudgetGroupDialog
          openConfirm={openEditBudgetModal}
          updateOpenConfirm={setOpenEditBudgetModal}
          budget={edittingBudget}
          newBudgetAmount={newBudgetAmount}
          setNewBudgetAmount={setNewBudgetAmount}
          okAction={handleEditBudget}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
